export default __webpack_public_path__ + "static/media/app1-11.40220e6f.gif";